import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/d6uiri67ipaugi04l9rg";

const contactInfo = [
  {
    icon: "ri-map-pin-2-line",
    label: "Address",
    value: "BOGE VELJANOVSKI 0, GOSTIVAR 1230, North Macedonia",
  },
  {
    icon: "ri-mail-line",
    label: "Email",
    value: "contact@badidoo.com",
  },
  {
    icon: "ri-phone-line",
    label: "Phone",
    value: "+1 3187129139",
  },
];

export default function ContactSection() {
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const body = new URLSearchParams(data as unknown as Record<string, string>).toString();

    setStatus("sending");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body,
      });
      if (res.ok) {
        setStatus("success");
        form.reset();
        setCharCount(0);
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <section id="contact" className="bg-[#111111] py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase text-[#00d4ff] mb-4">
            Contact Us
          </span>
          <h2 className="text-5xl font-bold text-white leading-tight">Get in Touch</h2>
          <p className="text-[#7a7a7a] text-lg mt-4 max-w-xl mx-auto">
            Have a question about our products? We&apos;d love to hear from you.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Contact info */}
          <div className="flex flex-col gap-8">
            <div>
              <h3 className="text-2xl font-bold text-white mb-6">Contact Information</h3>
              <div className="flex flex-col gap-6">
                {contactInfo.map((item) => (
                  <div key={item.label} className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-lg bg-[#00d4ff]/10">
                      <i className={`${item.icon} text-xl text-[#00d4ff]`}></i>
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-widest text-[#555] mb-1">{item.label}</p>
                      <p className="text-[#ccc] text-base">{item.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Address card */}
            <div className="bg-[#1a1a1a] border border-[#272727] rounded-xl p-6">
              <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">
                Registered Office
              </h4>
              <div className="flex flex-col gap-2 text-[#7a7a7a] text-sm">
                <div className="flex gap-3">
                  <span className="text-[#444] w-16 flex-shrink-0 uppercase text-xs tracking-wider">Street</span>
                  <span className="text-[#bbb]">BOGE VELJANOVSKI 0</span>
                </div>
                <div className="flex gap-3">
                  <span className="text-[#444] w-16 flex-shrink-0 uppercase text-xs tracking-wider">City</span>
                  <span className="text-[#bbb]">GOSTIVAR</span>
                </div>
                <div className="flex gap-3">
                  <span className="text-[#444] w-16 flex-shrink-0 uppercase text-xs tracking-wider">Zip</span>
                  <span className="text-[#bbb]">1230</span>
                </div>
                <div className="flex gap-3">
                  <span className="text-[#444] w-16 flex-shrink-0 uppercase text-xs tracking-wider">Country</span>
                  <span className="text-[#bbb]">North Macedonia</span>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="bg-[#1a1a1a] border border-[#272727] rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-white mb-6">Send a Message</h3>

            {status === "success" ? (
              <div className="flex flex-col items-center justify-center py-12 gap-4 text-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#00d4ff]/15">
                  <i className="ri-checkbox-circle-line text-3xl text-[#00d4ff]"></i>
                </div>
                <p className="text-white text-lg font-semibold">Message Sent!</p>
                <p className="text-[#7a7a7a] text-sm">We&apos;ll get back to you as soon as possible.</p>
                <button
                  onClick={() => setStatus("idle")}
                  className="mt-2 text-[#00d4ff] text-sm underline cursor-pointer"
                >
                  Send another message
                </button>
              </div>
            ) : (
              <form
                data-readdy-form
                id="contact-form"
                onSubmit={handleSubmit}
                className="flex flex-col gap-5"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="flex flex-col gap-1">
                    <label className="text-xs uppercase tracking-widest text-[#555]">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="full_name"
                      required
                      placeholder="Jane Smith"
                      className="bg-[#111] border border-[#333] rounded-lg px-4 py-3 text-sm text-white placeholder-[#444] outline-none focus:border-[#00d4ff]/60 transition-colors"
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="text-xs uppercase tracking-widest text-[#555]">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="jane@example.com"
                      className="bg-[#111] border border-[#333] rounded-lg px-4 py-3 text-sm text-white placeholder-[#444] outline-none focus:border-[#00d4ff]/60 transition-colors"
                    />
                  </div>
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-xs uppercase tracking-widest text-[#555]">
                    Subject
                  </label>
                  <input
                    type="text"
                    name="subject"
                    required
                    placeholder="How can we help?"
                    className="bg-[#111] border border-[#333] rounded-lg px-4 py-3 text-sm text-white placeholder-[#444] outline-none focus:border-[#00d4ff]/60 transition-colors"
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-xs uppercase tracking-widest text-[#555] flex justify-between">
                    <span>Message</span>
                    <span className={charCount > 500 ? "text-red-400" : "text-[#444]"}>
                      {charCount}/500
                    </span>
                  </label>
                  <textarea
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    placeholder="Write your message here..."
                    onChange={(e) => setCharCount(e.target.value.length)}
                    className="bg-[#111] border border-[#333] rounded-lg px-4 py-3 text-sm text-white placeholder-[#444] outline-none focus:border-[#00d4ff]/60 transition-colors resize-none"
                  />
                </div>

                {status === "error" && (
                  <p className="text-red-400 text-sm">
                    Something went wrong. Please try again.
                  </p>
                )}

                <button
                  type="submit"
                  disabled={status === "sending" || charCount > 500}
                  className="w-full py-3 rounded-lg bg-[#00d4ff] text-[#0a0a0a] font-semibold text-sm tracking-wider uppercase transition-opacity duration-200 hover:opacity-90 disabled:opacity-50 cursor-pointer whitespace-nowrap"
                >
                  {status === "sending" ? "Sending..." : "Send Message"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
